import { useGtm } from '@gtm-support/vue-gtm'

import { DOWNLOAD_GTM_EVENTS } from '@features/apps/constants'

/**
 * Предоставляет типизированные обработчики GTM-событий скачивания приложения.
 *
 * @returns функции отслеживания кликов по store и CTA
 */
export const useDownloadTracking = () => {
  const gtm = useGtm()

  const trackEvent = (event: string) => {
    if (!gtm) return
    gtm.trackEvent({ event })
  }

  return {
    trackEvent,
    trackStoreApple: () => trackEvent(DOWNLOAD_GTM_EVENTS.storeApple),
    trackStoreGoogle: () => trackEvent(DOWNLOAD_GTM_EVENTS.storeGoogle),
    trackCtaMobile: () => trackEvent(DOWNLOAD_GTM_EVENTS.ctaMobile),
  }
}
